import { render, staticRenderFns } from "./bussnessDetailYG.vue?vue&type=template&id=116f51f9&scoped=true"
import script from "./bussnessDetailYG.vue?vue&type=script&lang=ts"
export * from "./bussnessDetailYG.vue?vue&type=script&lang=ts"
import style0 from "./bussnessDetailYG.vue?vue&type=style&index=0&id=116f51f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116f51f9",
  null
  
)

export default component.exports